require('dotenv').config()

const COLONIAS_POSTAL = "https://api.copomex.com/query/info_cp/"
export default COLONIAS_POSTAL